import { useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import CandidateLandingPage from './CandidateLandingPage';
import { UploadProvider } from './UploadContext';

function App() {
  const [uploadId, setUploadId] = useState(null);

  return (
    <UploadProvider value={{ uploadId, setUploadId }}>
      <Routes>
        <Route 
          path="/" 
          element={<CandidateLandingPage setUploadId={setUploadId} />} 
        />
      </Routes>
    </UploadProvider>
  );
}

export default App;
